/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedResultContainer_viewer = {
    readonly isFavoritesEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_viewer" | "BuySharedItemTrackingProvider_viewer">;
    readonly " $refType": "BuySharedResultContainer_viewer";
};
export type BuySharedResultContainer_viewer$data = BuySharedResultContainer_viewer;
export type BuySharedResultContainer_viewer$key = {
    readonly " $data"?: BuySharedResultContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedResultContainer_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedResultContainer_viewer",
  "selections": [
    {
      "alias": "isFavoritesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuySharedItemTrackingProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'cf22471f64886f9343f50684fb2e0fc9';
export default node;
